import { ComponentProps } from 'react'
import { twMerge } from 'tailwind-merge'
import { tv, VariantProps } from 'tailwind-variants'
import { Icon, IconProps } from '~/ui/Icon'

const alertStyles = tv({
  slots: {
    base: 'border rounded p-2 flex gap-2 items-center',
    icon: 'shrink-0',
  },
  variants: {
    severity: {
      info: { base: 'bg-blue-500/25 border-blue-500', icon: 'text-blue-500' },
      error: { base: 'bg-red-500/25 border-red-500', icon: 'text-red-500' },
      warn: { base: 'bg-yellow-500/25 border-yellow-500', icon: 'text-yellow-500' },
      success: { base: 'bg-green-500/25 border-green-500', icon: 'text-green-500' },
    },
  },
  defaultVariants: {
    severity: 'info',
  },
})

type AlertProps = {
  severity?: VariantProps<typeof alertStyles>['severity']
} & ComponentProps<'div'>

const getIcon = (severity: NonNullable<AlertProps['severity']>): IconProps['name'] => {
  return (
    {
      info: 'info',
      error: 'warn',
      warn: 'warn',
      success: 'checkCircle',
    } as const
  )[severity]
}

export const Alert = ({ severity = 'info', children, className, ...props }: AlertProps) => {
  const { base, icon } = alertStyles({ severity })
  return (
    <div {...props} className={twMerge(className, base())}>
      <Icon name={getIcon(severity)} className={icon()} />
      {children}
    </div>
  )
}
